<template>
    <div  class="footer">
        <div class="footer-info">
            <span  v-for="(item,index) in infoList" :key="index" @click='toPage(item)'>{{item.value}}</span>
        </div> 
        <!-- <p class="footer-info">单位官网 </p> -->
        <div class="footer-info relation">
            <div class="tit">联系我们 </div>
            <div>中国中医科学院中医药信息研究所 中医药大健康智能研发中心 北京市东城区东直门内南小街16号 100700 联系电话：010-64089578
                <!-- <p>中国中医科学院中医药信息研究所 中医药大健康智能研发中心</p> 
                <p>北京市东城区东直门内南小街16号 100700</p>
                <p>联系电话：010-64089578</p> -->
            </div>
            

        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            infoList:[
                {
                    value:'平台介绍',
                    path:'/introPlatform'

                },
                {
                    value:'单位官网',
                    url:'http://www.cintcm.ac.cn/'
                }
            ]
        }
    } ,
    methods: {
        toPage(item){ 
            let url='';
            if(item.path){
                let routeUrl = this.$router.resolve(item.path); 
                url = routeUrl.href  
            }
            if(item.url){ 
               url=item.url; 
            }
             window.open(url, "_blank");
        },
    }
}
</script>

<style lang="less" scoped>

</style>